// extracted by mini-css-extract-plugin
export var brand = "_7a-8";
export var compact = "_7a-5";
export var extraSmall = "_7a-6";
export var icon = "_7a-0";
export var large = "_7a-3";
export var light = "_7a-1";
export var medium = "_7a-4";
export var outline = "_7a-a";
export var primaryDark = "_7a-9";
export var primaryLight = "_7a-7";
export var primaryModern = "_7a-b";
export var success = "_7a-2";